import React from "react";
import { DoodleStar } from "../brand";

/**
 * Founder's story — Stitch our-story; stacks text → image on mobile.
 */
const Findourvillage = () => {
  return (
    <section className="pt-10 sm:pt-16 md:pt-24 pb-16 sm:pb-20 md:pb-28 bg-surface-white relative text-left">
      <div className="max-w-7xl mx-auto px-5 sm:px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 sm:gap-12 lg:gap-16 items-center">
          <div className="lg:col-span-7 flex flex-col items-start order-1">
            <div className="flex items-center gap-2 mb-3 sm:mb-4">
              <svg
                fill="none"
                height="22"
                width="22"
                viewBox="0 0 24 24"
                className="text-heart-teal shrink-0"
                stroke="currentColor"
                strokeWidth="1.5"
                aria-hidden="true"
              >
                <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" />
              </svg>
              <span className="text-spectrum-blue font-headline text-xs font-semibold tracking-wide">
                Personal Reflection
              </span>
            </div>

            <h2 className="font-headline font-extrabold text-2xl sm:text-3xl lg:text-4xl text-ink mb-6 sm:mb-8 tracking-tight">
              Finding Our Village
            </h2>

            <div className="space-y-5 sm:space-y-6 font-body text-[15px] sm:text-base md:text-lg text-muted max-w-xl leading-relaxed">
              <p>
                Parenting is a journey filled with unexpected turns. When my son
                was diagnosed with autism, I found myself searching for guidance
                and connection. As a parent of a neurodivergent child, while
                resources for children were available, there was a crucial
                gap—support for parents and caregivers navigating this unique
                path.
              </p>
              <p>
                Those early days taught me the profound strength that comes from
                shared experiences. Each connection with another parent brought
                invaluable insights and a sense of belonging. Yet, finding these
                connections remained challenging for many families in the
                neurodivergent community.
              </p>
              <p>
                This realization sparked Social Spectrum a space I wished for
                during my own journey. A platform where every parent feels
                understood, supported, and empowered.
              </p>
            </div>

            <div className="mt-8 sm:mt-10 pt-5 sm:pt-6 border-t border-hairline w-full max-w-md">
              <p className="font-accent-hand text-2xl sm:text-3xl md:text-4xl text-heart-teal tracking-wide mb-1 select-none">
                Archana Akhaury
              </p>
              <p className="font-headline text-sm font-semibold text-ink">
                Founder, Social Spectrum
              </p>
            </div>
          </div>

          <div className="lg:col-span-5 relative order-2 w-full max-w-lg mx-auto lg:max-w-none lg:mx-0">
            <div
              className="bg-mist-halo absolute -inset-3 sm:-inset-4 rounded-3xl blur-xl -z-10 hidden sm:block"
              aria-hidden="true"
            />
            <DoodleStar
              className="absolute -top-3 left-1 sm:-top-5 sm:-left-4 z-20 pointer-events-none"
              size={28}
            />
            <div className="relative rounded-brand overflow-hidden border border-hairline shadow-brand-md bg-surface-white p-1.5 sm:p-2">
              <img
                src={
                  process.env.PUBLIC_URL +
                  "/images/photos/story-village-picnic.webp"
                }
                alt="Three generations of family laughing together over a picnic in the park"
                className="w-full h-[260px] sm:h-[360px] lg:h-[440px] object-cover rounded-brand"
              />
              <div className="absolute bottom-4 right-4 sm:bottom-6 sm:right-6 bg-white-chip backdrop-blur-sm px-3 py-1.5 sm:px-4 sm:py-2 rounded-brand border border-hairline shadow-sm flex items-center gap-2 max-w-[calc(100%-2rem)]">
                <svg
                  fill="none"
                  height="18"
                  width="18"
                  viewBox="0 0 24 24"
                  className="text-heart-teal shrink-0"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  aria-hidden="true"
                >
                  <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" />
                </svg>
                <span className="text-[11px] sm:text-xs font-semibold text-ink font-headline truncate">
                  Our living village
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Findourvillage;
